import { useEffect } from "react";

/**
 * Custom React hook to focus on the first error field when there are form submission errors.
 * @param {Object} errors - Object containing form validation errors.
 * @param {boolean} isSubmitting - Boolean indicating if the form is currently being submitted.
 * @author Ayan Ghosh
 */
export default function useFocusErrorField(errors, isSubmitting) {
   useEffect(() => {
      // Focus on the first error field if there are any errors and the form is being submitted
      if (Object.keys(errors).length && isSubmitting) {
         // Attempt to focus on the first element with the name corresponding to the first error field
         document.getElementsByName(Object.keys(errors)?.[0])?.[0]?.focus();
      }
   }, [errors, isSubmitting]);
}
